import { Attribute, Relationship, Resource } from 'json-api';
import { Translatable } from 'src/app/translation/translatable';
import { AtomResource } from '../classes/atom-resource';
import { Firm } from './firm.resource';
import { Product } from './product.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';

@Resource({
  type: 'trademarks',
})
export class Trademark extends AtomResource {
  @Attribute() name?: string;
  @Attribute({ key: 'official_name' }) officialName?: Translatable;
  @Attribute({ key: 'didomi_consent_id' }) didomiConsentId?: string;

  @Relationship() firm?: Firm;
  @Relationship() products?: Product[];
}

export class TrademarksConfig implements ResourceConfig {
  hosted = 'firm';
  tables = {
    options: {
      copy: true,
    },
    includes: [],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'name',
        displayedDatas: [
          {
            path: ['name'],
            class: 'mat-body-2',
          },
          {
            path: ['officialName'],
            class: 'mat-body-1',
          },
        ],
        header: 'Name / Official Name',
        displayed: true,
        sort: 'name',
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'didomi',
        displayedDatas: [
          {
            path: ['didomiConsentId'],
            class: 'mat-body-2',
          },
        ],
        header: 'Didomi ID',
        displayed: true,
        sort: 'didomi_consent_id',
        options: {
          copy: true,
        },
      },
      // {
      //   columnDef: 'firms',
      //   header: 'Firms',
      //   displayed: true,
      //   link: {
      //     resource: 'firms',
      //     list: 'firms',
      //     target: 'trademarks',
      //   },
      // },
      {
        columnDef: 'products',
        header: 'Products',
        displayed: true,
        link: {
          resource: 'products',
          list: 'products',
          target: 'trademark',
        },
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'business',
      title: [
        {
          path: ['name'],
          translatable: false,
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        list: [
          {
            icon: 'copyrights',
            title: 'Official Name',
            APIKey: 'officialName',
            value: {
              path: ['officialName'],
            },
          },
          {
            icon: 'numbers',
            title: 'Didomi ID',
            APIKey: 'didomi_consent_id',
            value: {
              path: ['didomiConsentId'],
            },
          },
          {
            icon: 'public',
            title: 'Products',
            APIKey: 'products',
            link: {
              resource: 'products',
              list: 'products',
              target: 'trademark',
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Trademark',
        formGroup: 'trademark',
        list: [
          {
            type: 'text',
            title: 'Name',
            APIKey: 'name',
            formControl: 'name',
            required: true,
            translatable: false,
            noCols: true,
          },
          {
            type: 'text',
            title: 'Official Name',
            APIKey: 'officialName',
            formControl: 'officialName',
            required: true,
            translatable: true,
            noCols: true,
          },
          {
            type: 'text',
            title: 'Didomi ID',
            formControl: 'didomiConsentId',
            APIKey: 'didomiConsentId',
            translatable: false,
            required: false,
            hint: 'Must be 8 characters',
            noCols: true,
          },
        ],
      },
    ],
  };
  resource = Trademark;
  resourceName = 'Trademarks';
  resourceKey = 'trademarks';
  resourceKeySingle = 'trademark';
  includes = ['firm', 'products.country'];
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('name', 'Name', true),
    new StringFilter('didomi_consent_id', 'Didomi ID'),
    new StringFilter('firm.name', 'Firm name'),
    new NumberFilter('firm.id', 'Firm ID'),
    new StringFilter('product.name', 'Product name'),
    new NumberFilter('product.id', 'Product ID'),
    new StringFilter('product.country.id', 'Country ID'),
  ];
  constructor() {}
}
